(function () {
  console.log("Loose Search Loaded");

  const SYN = {
    pih: "pigmentation",
    pihm: "pigmentation",
    pihn: "pigmentation",
    pign: "pigmentation",
    peg: "pigmentation",
    pig: "pigmentation",
    pigm: "pigmentation",
    pigme: "pigmentation",
    pigmen: "pigmentation",
    pigment: "pigmentation",
    pigmentaion: "pigmentation",
    pigmantation: "pigmentation",
    pgm: "pigmentation",
    pg: "pigmentation",
    pgm: "pigmentation",
    pgmn: "pigmentation",
    peg: "pigmentation",
    pemg: "pigmentation",
    pgment: "pigmentation",

    hairfall: "hair fall",
    hairfal: "hair fall",
    "hair fal": "hair fall",

    dandruf: "dandruff",
    dandraf: "dandruff",

    darkspot: "dark spots",
    darkspots: "dark spots",

    detan: "tan",
    "de tan": "tan"
  };

  let products = [];
  let loaded = false;
  let loading = false;

  function norm(q) {
    q = String(q || "").toLowerCase().trim();
    return SYN[q] || q;
  }

  async function loadProducts() {
    if (loaded || loading) return;
    loading = true;

    let all = [];

    for (let page = 1; page <= 10; page++) {
      try {
        const res = await fetch(`/products.json?limit=250&page=${page}`);
        const data = await res.json();

        if (!data.products || !data.products.length) break;

        all = all.concat(data.products);

        if (data.products.length < 250) break;
      } catch (e) {
        console.error("Loose search products error:", e);
        break;
      }
    }

    products = all.map((p) => ({
      title: p.title || "",
      url: "/products/" + p.handle,
      image: p.images && p.images[0] ? p.images[0].src : "",
      price: p.variants && p.variants[0] ? p.variants[0].price : "",
      text: (
        (p.title || "") +
        " " +
        ((p.tags || []).join(" ")) +
        " " +
        (p.product_type || "") +
        " " +
        (p.vendor || "") +
        " " +
        ((p.body_html || "").replace(/<[^>]*>/g, " "))
      ).toLowerCase()
    }));

    loaded = true;
    loading = false;

    console.log("Loose Search Products:", products.length);
  }

  function findProducts(query) {
    const q = norm(query);

    return products
      .map((p) => {
        let score = 0;

        if (p.text.includes(q)) score += 100;
        if (p.title.toLowerCase().includes(q)) score += 200;

        q.split("").forEach((ch) => {
          if (p.text.includes(ch)) score += 1;
        });

        return { product: p, score };
      })
      .filter((x) => x.score > 5)
      .sort((a, b) => b.score - a.score)
      .slice(0, 6)
      .map((x) => x.product);
  }

  function money(price) {
    if (!price) return "";
    return "₹" + Math.round(Number(price));
  }

  function render(input, items, query) {
    const form = input.closest("form");
    if (!form) return;

    const predictiveBox = form.querySelector(".predictive-search");
    const resultBox = form.querySelector("#predictive-search-results");

    if (!predictiveBox || !resultBox) return;

    predictiveBox.style.display = "block";
    predictiveBox.style.visibility = "visible";
    predictiveBox.style.opacity = "1";

    input.setAttribute("aria-expanded", "true");

    resultBox.innerHTML = `
      <div class="ls-results">
        <h2 class="predictive-search__heading text-body caption-with-letter-spacing">
          Showing closest matches for “${query}”
        </h2>

        <ul class="predictive-search__results-list list-unstyled" role="group">
          ${items
            .map(
              (p) => `
              <li class="predictive-search__list-item" role="option">
                <a href="${p.url}" class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text">
                  ${
                    p.image
                      ? `<img class="predictive-search__image" src="${p.image}" width="50" height="50" loading="lazy">`
                      : ""
                  }
                  <div class="predictive-search__item-content">
                    <p class="predictive-search__item-heading h5">${p.title}</p>
                    <span class="ls-price">${money(p.price)}</span>
                  </div>
                </a>
              </li>
            `
            )
            .join("")}
        </ul>
      </div>
    `;
  }

  let timer;

  async function runSearch(input) {
    const q = input.value.trim();

    if (q.length < 2) return;

    await loadProducts();

    const items = findProducts(q);

    if (items.length) {
      render(input, items, q);
    }
  }

  document.addEventListener("input", function (e) {
    if (!e.target.matches("#Search-In-Modal, .search__input, input[type='search'][name='q']")) return;

    clearTimeout(timer);

    timer = setTimeout(function () {
      runSearch(e.target);
    }, 800);
  });

  document.addEventListener("focusin", function (e) {
    if (!e.target.matches("#Search-In-Modal, .search__input, input[type='search'][name='q']")) return;

    if (e.target.value.trim().length >= 2) {
      runSearch(e.target);
    }
  });
})();